























import dayjs from 'dayjs'
import { Component, Vue, Prop } from 'vue-property-decorator'

import LoadingPlaceholder from '@/components/LoadingPlaceholder.vue'

import Booking from '@/models/booking'
import BookingStatus from '@/models/booking-status'

@Component({
  components: {
    LoadingPlaceholder,
  },
})
export default class BookingDates extends Vue {
  @Prop() booking!: Booking

  get showExpiryDate() {
    return this.booking?.status === BookingStatus.AWAITING_PAYMENT
  }

  get showPaymentDueDate() {
    return (
      this.booking?.paidCents > 0 &&
      this.booking?.paidCents < this.booking.totalCents
    )
  }

  get showDates() {
    return (
      this.booking?.status !== BookingStatus.CANCELLED &&
      (this.showExpiryDate || this.showPaymentDueDate)
    )
  }

  get bookingExpire() {
    return dayjs.utc(this.booking.expire)
  }

  get bookingPaymentDueDate() {
    return dayjs.utc(this.booking.paymentDueDate)
  }
}
